module.exports = __webpack_public_path__ + "fonts/TTFirs-Bold.77ef70a7.woff";